'use strict';

var getSelection = require('./getSelection');
var setSelection = require('./setSelection');

module.exports = {
  get: getSelection,
  set: setSelection
};



//////////////////
// WEBPACK FOOTER
// ./~/seleccion/src/seleccion.js
// module id = 303
// module chunks = 0